module.exports = __webpack_public_path__ + "img/estp-selected.52c7aed6.png";